import { ReactNode } from "react";
import { Grid, TableCell, TableRow, Typography } from "@mui/material";

type TableRowLayoutProps = Readonly<{
  title: string;
  floorApartmentSubtitle?: string;
  streetAddressSubtitle?: string;
  description: ReactNode;
  recommendations: ReactNode;
}>;

export function TableRowLayout({
  title,
  floorApartmentSubtitle,
  streetAddressSubtitle,
  description,
  recommendations,
}: TableRowLayoutProps) {
  return (
    <TableRow>
      <TableCell width="20%">
        <Grid container direction="column">
          <Typography variant="labelLarge">{title}</Typography>
          {streetAddressSubtitle && (
            <Typography variant="bodyMedium" color="text.secondary">
              {streetAddressSubtitle}
            </Typography>
          )}
          {floorApartmentSubtitle && (
            <Typography variant="bodyMedium" color="text.secondary">
              {floorApartmentSubtitle}
            </Typography>
          )}
        </Grid>
      </TableCell>
      <TableCell width="40%">
        <Typography variant="bodyMedium">{description}</Typography>
      </TableCell>
      <TableCell width="40%">{recommendations}</TableCell>
    </TableRow>
  );
}
